import styled, { device, themeGet } from "../styled";

export const StyledCard = styled.div`
    width: 98%;
    margin: 5px;
    padding: 5px;
    background-color: var(--primary-color);
    border-radius: 2px;
    box-shadow: 5px 5px 8px rgba(0, 0, 0, 0.2);

    /* ${device.medium} {
        height: 60px;
    } */
    &:hover {
        background-color: var(--secondary-color);
        p {
            color: var(--primary-color);
        }
    }
    a {
        height: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        color: #fff;
        text-decoration: none;
        p {
            margin: 0 10px;
            font-size: 14px;
            font-weight: 500;
            flex: 1;
        }
    }
    img {
        height: 100%;
        width: 100%;
    }
`;
